import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  showAdminSidebar: boolean = false; 

  constructor(private cd: ChangeDetectorRef, private router: Router, private route: ActivatedRoute) {}

    ngAfterContentChecked() {
       this.cd.detectChanges(); 
       this.showAdminSidebar = this.router.url.includes('admin');
      }
}
